import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { motion } from "framer-motion";
import logowhite from "../assets/images/Logo.png"; // Update path as needed
import logoblack from "../assets/images/Logo 2.png"; // Update path as needed
import { useLocation } from "react-router-dom";

function CustomNavbar() {
  const location = useLocation();

  const menuItems = [
    { title: "Wie Zijn Wij", href: "/wie-zijn-wij", dropdown: false }, // Example of a simple link
    { title: "Diensten", dropdown: true },
    { title: "MVO / Sponsoring", dropdown: true },
    { title: "Nieuws", href: "/nieuws", dropdown: false },
    { title: "Inschrijven", dropdown: true },
  ];

  const isInschrijven = location.pathname === "/inschrijven";
  const isBlog = location.pathname.startsWith("/blog");
  const textColor = isInschrijven || isBlog ? "text-black" : "text-white";
  const logo = isInschrijven || isBlog ? logoblack : logowhite;

  // console.log(currentPath);

  console.log(textColor);

  return (
    <div className="absolute top-0 left-0 w-full z-20 bg-transparent">
      <Navbar expand="lg" className="bg-transparent">
        <Container>
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Navbar.Brand href="/" className="mx-auto">
              <img
                src={`${logo}`}
                alt="Logo"
                className="w-52" // Adjust size as needed
              />
            </Navbar.Brand>
          </motion.div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto md:gap-6">
              {menuItems.map((item, index) =>
                item.dropdown ? (
                  <motion.div
                    key={item.title}
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 * index }}
                  >
                    <NavDropdown
                      title={
                        <span className={`${textColor}`}>{item.title}</span>
                      }
                      id={`basic-nav-dropdown-${index}`}
                      className="text-white"
                    >
                      {getDropdownItems(item.title)}
                    </NavDropdown>
                  </motion.div>
                ) : (
                  <motion.div
                    key={item.title}
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 * index }}
                  >
                    <Nav.Link href={item.href} className={`${textColor}`}>
                      {item.title}
                    </Nav.Link>
                  </motion.div>
                )
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {/* Fullscreen menu for mobile */}
      <style jsx>{`
        @media (max-width: 991.98px) {
          .navbar-collapse {
            top: 0;
            right: 0;
            height: 100%;
            width: 100%;
            background-color: #284b5a; /* Background color of full-screen menu */
            z-index: 9999;
            padding-top: 3rem;
            padding-bottom: 3rem;
            overflow-y: auto;
          }
          .navbar-nav {
            margin: auto;
            text-align: center;
          }
          .nav-item {
            margin: 1rem 0; /* Adjust spacing between items */
          }
        }
        .navbar-toggler {
          border: none;
        }
        .navbar-toggler-icon {
          background-image: none;
        }
        .navbar-toggler-icon:before {
          content: "\\2630"; /* Unicode for hamburger icon */
          font-size: 1.5rem;
          color: white;
        }
        .absolute {
          position: absolute;
        }
        .top-4 {
          top: 1rem;
        }
        .right-4 {
          right: 1rem;
        }
      `}</style>
    </div>
  );

  function getDropdownItems(title) {
    switch (title) {
      case "Diensten":
        return (
          <>
            <NavDropdown.Item href="/crossborder-recruitment-en-detachering">
              Crossborder Recruitment en detachering
            </NavDropdown.Item>
            <NavDropdown.Item href="/sales-en-finance">
              Sales en Finance
            </NavDropdown.Item>
            <NavDropdown.Item href="/inkoop-en-logistiek">
              Inkoop en Logistiek
            </NavDropdown.Item>
            <NavDropdown.Item href="/hr-en-organisatieadvies">
              HR en Organisatieadvies
            </NavDropdown.Item>
            <NavDropdown.Item href="/overige-diensten">
              Overige Diensten
            </NavDropdown.Item>
          </>
        );
      case "MVO / Sponsoring":
        return (
          <>
            <NavDropdown.Item href="/maatschappelijk-verantwoord-ondernemen">
              MVO
            </NavDropdown.Item>
            <NavDropdown.Item href="/sponsoring">Sponsoring</NavDropdown.Item>
          </>
        );
      case "Inschrijven":
        return (
          <>
            <NavDropdown.Item href="/inschrijven">
              Formulier Om In Te Schrijven En CV Op Te Laden
            </NavDropdown.Item>
          </>
        );
      default:
        return null;
    }
  }
}

export default CustomNavbar;
